import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';


const ReviewsPerformanceTrendsGraph: React.FunctionComponent<{
	reviewsState: CompetitorReviewsState
}> = ({ reviewsState }) => {

	const options: Highcharts.Options = useMemo(() => {
		const categories = ['Score', 'Response Rate', 'Positivity'];
		const data = [
			reviewsState.statistics.score * 10,
			reviewsState.statistics.responseRate * 100,
			reviewsState.statistics.positivityRate * 100,
		];

		return {
			chart: {
				type: 'column',
			},
			title: {
				text: undefined,
			},
			xAxis: {
				categories: categories,
				title: {
					text: undefined,
				},
			},
			yAxis: {
				title: {
					text: 'Score %',
				},
				min: 0,
				max: 100,
			},
			tooltip: {
				shared: true,
				valueSuffix: '%',
				valueDecimals: 1,
			},
			legend: {
				align: 'center',
				verticalAlign: 'bottom',
				layout: 'horizontal',
			},
			plotOptions: {
				line: {
					marker: {
						enabled: true,
						radius: 4,
					},
					lineWidth: 2,
				},
			},
			series: [
				{
					name: 'Performance',
					type: 'column',
					data: data,
					color: '#7cb5ec',
				},
			],
			credits: {
				enabled: false,
			},
		};
	}, [reviewsState.statistics]);

	return <div className="h-full w-full flex items-center justify-center p-4">
		<div className="w-full" style={{ height: '100%' }}>
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
				containerProps={{ style: { height: '100%', width: '100%' } }}
			/>
		</div>
	</div>;

};

export default ReviewsPerformanceTrendsGraph;
